@import "../../variables.scss";

.profile {
  &__bookings {
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    @media (max-width: $size-sm) {
      flex-direction: column;
    }
    &_title {
      display: flex;
      align-items: center;
      font-size: 20px;
      line-height: 24px;
      font-weight: bold;
    }
    &_button {
      height: 40px;
      width: 160px;
      font-weight: bold;
      @media (max-width: $size-sm) {
        margin-top: 1rem;
        width: 100%;
      }
    }
  }
}
